<template>
    <div class="m-x-3-lg m-x-2-md m-y-2-md">
        <span class="titulo-seccion">Experiencias exitosas de transición al MEIA</span>
        <h1 class="titulo">Videos</h1>
        <div class="contenedor-videos">
            <CoverLink
                url="https://www.youtube.com/watch?v=iA-rz2PgSkw&t=0s&ab_channel=Agricultura"
                name="Producción agrícola y frutícola comercial con alternativas agroecológicas" 
                cover="https://img.youtube.com/vi/iA-rz2PgSkw/hqdefault.jpg" />
            <CoverLink
                url="https://www.youtube.com/watch?v=Kdn2PDJWm_g&t=0&ab_channel=Agricultura" 
                name="Agricultura Regenerativa y Diseño Hidrológico Keyline"
                cover="https://img.youtube.com/vi/Kdn2PDJWm_g/hqdefault.jpg"/>
            <CoverLink
                url="https://www.youtube.com/watch?v=hWhVqtc8XDM&t=0s&ab_channel=Agricultura" 
                name="Transición agroecológica de productores de pequeña y mediana escala, sin uso de glifosato"
                cover="https://img.youtube.com/vi/hWhVqtc8XDM/hqdefault.jpg"/>
            <CoverLink
                url="https://www.youtube.com/watch?v=zRqt3A1UoAw&t=0s&ab_channel=Agricultura" 
                name="Cosecha de #maíz blanco de Sinaloa, otoño/invierno 2020-2021"
                cover="https://img.youtube.com/vi/zRqt3A1UoAw/hqdefault.jpg"/>

            <CoverLink
                url="https://www.youtube.com/watch?v=e2Gd5DdOZOs&ab_channel=CampoTV" 
                name="Producción de naranja orgánica "
                cover="https://img.youtube.com/vi/e2Gd5DdOZOs/hqdefault.jpg"/>
        </div>
    </div>
</template>

<script>
import CoverLink from '@/components/CoverLink.vue'

export default {
  name: "Enlaces",
  components: {
      CoverLink
  },
  mounted() {
    this.$store.commit('setTemaAlternativa', 'Experiencias exitosas de transición al MEIA');
    this.$store.commit('setSubtemaAlternativa', 'Enlaces');
  },
};
</script>

<style lang="scss">
.contenedor-videos {
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    display: grid;
    gap: $space;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 0px;
  }
}
</style>
